export const STEPS = [0, 1, 2, 3];
export const [FIRST, SECOND, THIRD] = STEPS;
